import { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next'
import React from 'react'
import { Breadcrumbs } from '../components/Breadcrumbs'
import { Content } from '../components/Content'
import { Intro } from '../components/Intro'
import { MissingContent } from '../components/MissingContent'
import { Seo } from '../components/Seo'
import { Spacer } from '../components/Spacer'
import { WidthBound } from '../components/WidthBound'
import { PageFragment } from '../src/model/fragments'
import { DEFAULT_LOCALE, getLocale, getPossibleLocales, Locale } from '../src/model/locale'
import { axiosGet } from '../src/utils/axiosWrapper'

export default function Page({
	page,
	locales,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
	if (!page) {
		return <MissingContent />
	}

	const data = getLocale(page.locales, locales)

	if (!data) {
		return <MissingContent />
	}

	return (
		<>
			<Seo seo={data.seo} />
			<Breadcrumbs
				items={[
					{
						label: data.title,
					},
				]}
			/>
			<Intro title={data.title} />
			<WidthBound size="normal">
				<Content content={data.content} innerSize="narrow" />
			</WidthBound>
			<Spacer initial={130} />
		</>
	)
}

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
	const locale = (ctx.query.locale || DEFAULT_LOCALE) as Locale
	const locales = getPossibleLocales(ctx.query.locale as Locale)
	const { getPage: page } = await axiosGet('/layout/page/get', {locale: locale, navigationId: ctx.query.id}) as {
		getPage: PageFragment
	};

	return { props: { page, locales } }
}
